export default __webpack_public_path__ + "static/media/imobpro-logo-secondary.008b8daa.svg";